export enum TaskStatus {
  NOT_STARTED,
  STARTED,
  SUCCESSFUL,
  ERROR,
}